import * as XLSX from 'xlsx';
import { DateHelper } from './dateHelper';
import { DebugHelper } from "@/helper/debugHelper";
import * as Encoding from 'encoding-japanese';
import * as SJIS from './sjis/encoding-sjis';

export class ExcelHelper
{
    public static csvBinaryToString(data : ArrayBuffer)
    {
        try
        {
            var array : Uint8Array | Uint16Array | Uint32Array = new Uint8Array(data);
            // 文字コードを取得
            var encode = Encoding.detect(array);
            // UTF16/32 は別の変換
            if(encode == "UTF16")
            {
                array = new Uint16Array(data);
            }
            else if(encode == "UTF32")
            {
                array = new Uint32Array(data);
            }
            else if(encode == "UNICODE" && SJIS.isSJIS_IBM(array))
            {
                DebugHelper.trace("csvBinaryToString: IBM拡張文字 -> NEC拡張文字");
                array = SJIS.sjisIBM_to_sjis(array);
            }
            // Unicodeへ変換
            var unicodeArray = Encoding.convert(array, 'UNICODE');
            // 文字列に変換
            var unicodeText = Encoding.codeToString(unicodeArray);

            return unicodeText;
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }
        return "";
    }

    public static xlsxBinaryToJsonString(data : ArrayBuffer)
    {
        try
        {
            var array = this.fixData(data);
            var wb = XLSX.read(btoa(array), { type : 'base64', cellNF : true, cellText : true, cellDates : true, dateNF : "YYYY/MM/DD" });
            this.fixWorkbook(wb);
            var output = this.toJson(wb);
            return JSON.stringify(output);
        }
        catch(e)
        {
            DebugHelper.trace(e);
        }
        return "";
    }

    public static xlsxBinaryToJsonStringWithSelectSheet(data : ArrayBuffer, 
        selection : (sheetNames : string[], callback : (index : number) => void) => void, 
        completion : (result : string) => void, 
        error : () => void)
    {
        try
        {
            var array = this.fixData(data);
            var wb = XLSX.read(btoa(array), { type : 'base64', cellNF : true, cellText : true, cellDates : true, dateNF : "YYYY/MM/DD" });
            this.fixWorkbook(wb);
            var sheetNames = wb.SheetNames;
            if(sheetNames.length > 1)
            {
                // 複数のシートが含まれる場合は選択処理を呼び出す
                selection(sheetNames, selectedIndex =>
                {
                    var output = this.toJson(wb, selectedIndex);
                    completion(JSON.stringify(output)); 
                });
            }
            else
            {
                // シートが一つだけなので、選択せず読み込む
                var output = this.toJson(wb, 0);
                completion(JSON.stringify(output)); 
            }
        }
        catch(e)
        {
            DebugHelper.trace(e);
            error();
        }
    }

    private static fixData(data : ArrayBuffer)
    {
        var o = "";
        var l = 0;
        var w = 10240;
        for(; l < data.byteLength / w; ++l)
        {
            var uint8Array1 = new Uint8Array(data.slice(l * w, l * w + w));
            o += String.fromCharCode.apply(null, [].slice.call(uint8Array1));
        }

        var uint8Array2 = new Uint8Array(data.slice(l * w));
        o += String.fromCharCode.apply(null, [].slice.call(uint8Array2));

        return o;
    }

    private static toJson(workbook : XLSX.WorkBook, sheetIndex : number = 0)
    {
        DebugHelper.trace(workbook);
        var result = {};
        var sheetLen = workbook.SheetNames.length;
        if(0 <= sheetIndex && sheetIndex < sheetLen)
        {
            var sheetName = workbook.SheetNames[sheetIndex];
            var roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { raw : false, blankrows : true, header : "A" });
            if(roa.length > 0) result = roa;
        }
        return result;
    }

    private static fixWorkbook(workbook : XLSX.WorkBook)
    {
        for(var i = 0; i < workbook.SheetNames.length; ++i)
        {
            let sheetName = workbook.SheetNames[i];
            let sheet = workbook.Sheets[sheetName];
            let rangeStr = sheet["!ref"];
            if(rangeStr != null)
            {
                let range = XLSX.utils.decode_range(rangeStr);
                for(let r = range.s.r; r <= range.e.r; ++r)
                {
                    for(let c = range.s.c; c <= range.e.c; ++c)
                    {
                        let cellRef = XLSX.utils.encode_cell({ r : r, c : c });
                        let cell = sheet[cellRef];
                        if(cell != null)
                        {
                            if(cell.t == "d" && cell.z == '[$-411]ggge"年"m"月"d"日";@')
                            {
                                // 平成E年M月D日
                                if(cell.v != null && cell.v instanceof Date)
                                {
                                    let date = cell.v as Date;
                                    let year = date.getFullYear();
                                    let month = date.getMonth() + 1;
                                    let day = date.getDate();
                                    let jpYear = DateHelper.getJapaneseYear(year, month, day, 1);
                                    cell.z = '"' + jpYear + '年"m"月"d"日";@';
                                    delete cell.w;
                                    XLSX.utils.format_cell(cell);
                                }
                            }
                            else if(cell.t == "n" && cell.z == '#,##0 ;[Red](#,##0)')
                            {
                                // 負の時に赤字になる場合のうち、小数点も単位もないパターンで()が残る問題
                                cell.z = '#,##0';
                                delete cell.w;
                                XLSX.utils.format_cell(cell);
                            }
                            else if(cell.t == "d" && cell.z == '"上午/下午 "hh"時"mm"分"ss"秒 "')
                            {
                                // 日付のユーザー定義対応
                                if(cell.v != null && cell.v instanceof Date)
                                {
                                    cell.z = 'm"月"d"日";@';
                                    delete cell.w;
                                    XLSX.utils.format_cell(cell);
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}